import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [data, setData] = useState(undefined);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setData(r.data);
    } catch {
      setData(null);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setData(null);
  }, []);

  return (
    <AuthCtx.Provider
      value={{
        data,
        setData,
        refresh,
        logout,
        user: data?.user || null,
        company: data?.company || {},
        planId: data?.plan_id || "gratis",
        plan: data?.plan || {},
        trialActive: !!data?.trial_active,
        trialEndsAt: data?.trial_ends_at,
      }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
